import { gql } from "@apollo/client";

export default gql`
  mutation TrackLastVisitOnCollections($collectionIds: [ObjectId!]!) {
    trackLastVisitOnCollections(collectionIds: $collectionIds)
  }
`;
